import { useNavigate } from 'react-router-dom';

import SessionModal from '../forms/session-modal';
import { saveDraft } from '../utils/draft';

// OPU creation — step 1 (floating session form). On continue, the header
// (farm + staff + date) is stashed as a draft and the items workspace opens in
// a NEW TAB (so the sidebar can't steal focus from the long form). The session
// itself is created by the compound POST when the workspace is saved (the
// contract requires ≥1 aspiration).

export default function OpuCreate() {
    const navigate = useNavigate();

    const handleConfirm = (header) => {
        const key = saveDraft(header);
        window.open(`/opu/session?draft=${key}`, '_blank', 'noopener');
        navigate('/admin/opu');
    };

    return <SessionModal onConfirm={handleConfirm} onCancel={() => navigate('/admin/opu')} />;
}
